import diplomaCurve from "@/assets/svg/diploma-curve.svg";
import edusognoLogoCertified from "@/assets/svg/edusogno-logo-certified.svg";
import edusognoPartners from "@/assets/svg/edusogno-partners-diploma.svg";
import { LoginUserItem } from "@/types";

interface DiplomaProps {
  english_course: string;
  start_month: string;
  english_level: string;
  course_duration: number;
  user?: LoginUserItem;
  type: string | null;
}

const PdfDiplomaPreview = ({
  english_course,
  start_month,
  english_level,
  course_duration,
  user,
  type,
}: DiplomaProps) => {
  const pot = type === "pot";
  const ielts = type === "ielts";
  const all = type === "all";
  return (
    <div className={"h-full flex"}>
      {/*<div*/}
      {/*  id="captureDiplomaPDF"*/}
      {/*  className="bg-white relative mx-auto font-sans px-5 flex flex-col justify-center items-center w-full max-w-full h-full max-h-[190mm]"*/}
      {/*>*/}
      {/*  <div className="max-w-[200px] lg:max-w-[300px] max-h-[250px] lg:max-h-[400px] absolute top-0 left-0">*/}
      {/*    <img*/}
      {/*      src={diplomaCurve}*/}
      {/*      className="object-cover object-center w-full h-full block"*/}
      {/*      alt=""*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*  <div className="max-w-[200px] lg:max-w-[300px] max-h-[250px] lg:max-h-[400px] absolute bottom-0 right-0 -rotate-180">*/}
      {/*    <img*/}
      {/*      src={diplomaCurve}*/}
      {/*      className="object-cover object-center w-full h-full block"*/}
      {/*      alt=""*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*  <div className="w-full max-w-[600px] h-full flex flex-col gap-y-5 justify-start items-center text-center py-10 2xl:py-20">*/}
      {/*    <div className="max-w-[125px] lg:max-w-[200px]">*/}
      {/*      <img*/}
      {/*        src={edusognoLogoCertified}*/}
      {/*        className="object-contain object-center w-full h-full block"*/}
      {/*        alt=""*/}
      {/*      />*/}
      {/*    </div>*/}
      {/*    <div>*/}
      {/*      <h1 className="text-xl lg:text-5xl font-semibold mb-8">*/}
      {/*        {english_course}*/}
      {/*      </h1>*/}
      {/*      <p className="text-sm lg:text-xl font-light text-brand">*/}
      {/*        <strong className="font-semibold">*/}
      {/*          {user?.nome} {user?.cognome}*/}
      {/*        </strong>{" "}*/}
      {/*        successfully participated in the Edusogno English course with*/}
      {/*        native-speaking tutors*/}
      {/*      </p>*/}
      {/*    </div>*/}
      {/*    <div className="flex flex-col  text-brand items-center gap-y-4">*/}
      {/*      <div>*/}
      {/*        <span className="text-sm lg:text-lg font-bold">Start date</span>*/}
      {/*        <p className="text-md lg:text-xl font-light">{start_month}</p>*/}
      {/*      </div>*/}
      {/*      <div>*/}
      {/*        <span className="text-sm lg:text-lg font-semibold">*/}
      {/*          Final Attained Level*/}
      {/*        </span>*/}
      {/*        <p className="text-md lg:text-xl font-light">*/}
      {/*          Cambridge {english_level} Level*/}
      {/*        </p>*/}
      {/*      </div>*/}
      {/*      <div>*/}
      {/*        <span className="text-sm lg:text-lg font-semibold">*/}
      {/*          Course Duration*/}
      {/*        </span>*/}
      {/*        <p className="text-md lg:text-xl font-light">*/}
      {/*          {course_duration} hours*/}
      {/*        </p>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*    <div className="flex flex-col justify-center items-center gap-y-4">*/}
      {/*      <p className="text-sm lg:text-lg font-semibold">*/}
      {/*        Edusogno partners*/}
      {/*      </p>*/}
      {/*      <div className="max-w-[350px] lg:max-w-full">*/}
      {/*        <img*/}
      {/*          src={edusognoPartners}*/}
      {/*          className="object-contain object-center w-full h-full block"*/}
      {/*          alt=""*/}
      {/*        />*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}

      {(pot || all) && (
        <div
          // id="captureDiplomaPDF"
          className="bg-white @container relative mx-auto text-edu-900 font-sans px-5 flex flex-col justify-center items-center w-full max-w-full lg:h-[full] lg:max-h-[190mm]"
        >
          <div className="max-w-[200px] lg:max-w-[300px] max-h-[250px] lg:max-h-[400px] absolute top-0 left-0">
            <img
              src={diplomaCurve}
              className="object-cover object-center w-full h-full block"
              alt=""
            />
          </div>
          <div className="max-w-[200px] lg:max-w-[300px] max-h-[250px] lg:max-h-[400px] absolute bottom-0 right-0 -rotate-180">
            <img
              src={diplomaCurve}
              className="object-cover object-center w-full h-full block"
              alt=""
            />
          </div>
          <div>
            <div className="w-full flex flex-col lg:gap-y-5 justify-evenly items-center text-center py-20">
              <div className="max-w-[80px] lg:max-w-[187] mt-4">
                <img
                  src={edusognoLogoCertified}
                  className="object-contain object-center w-full h-full block"
                  alt=""
                />
              </div>
              <div>
                <h1 className="text-xs @sm:text-lg @2xl:text-3xl font-semibold m-2 sm:mb-4 @lg:mb-8">
                  {english_course}
                </h1>
                <p className="text-[8px] @sm:text-sm font-light leading-tight @sm:leading-5">
                  <strong className="font-semibold">
                    {user?.first_name} {user?.last_name}
                  </strong>{" "}
                  successfully participated in the <br /> Edusogno English
                  course with native-speaking tutors
                </p>
                <p className="text-[8px] @sm:text-sm font-semibold">
                  {start_month}
                </p>
              </div>
              <div className="flex flex-row justify-between items-center gap-x-14 mb-2">
                <div className="flex flex-col">
                  <span className="text-[8px] @sm:text-sm font-light leading-tight">
                    Level
                  </span>
                  <p className="text-[8px] @sm:text-lg font-semibold leading-none">
                    {english_level}
                  </p>
                </div>
                <div className="flex flex-col">
                  <span className="text-[8px] @sm:text-sm font-light leading-tight">
                    Course Duration
                  </span>
                  <p className="text-[8px] @sm:text-lg font-semibold leading-none">
                    {course_duration} hours
                  </p>
                </div>
              </div>
              <div className="flex flex-row justify-around items-center gap-x-8 ">
                <p className="text-[8px] @sm:text-sm font-light">
                  Edusogno partners
                </p>
                <div className="max-w-[80px] @4xl:max-w-full">
                  <img
                    src={edusognoPartners}
                    className="object-contain object-center w-full h-full block"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {ielts && (
        <div
          // id="captureDiplomaPDF"
          className="bg-white @container relative mx-auto text-edu-900 font-sans px-5 flex flex-col justify-center items-center w-full max-w-full lg:h-[full] lg:max-h-[190mm]"
        >
          <div className="max-w-[200px] lg:max-w-[300px] max-h-[250px] lg:max-h-[400px] absolute top-0 left-0">
            <img
              src={diplomaCurve}
              className="object-cover object-center w-full h-full block"
              alt=""
            />
          </div>
          <div className="max-w-[200px] lg:max-w-[300px] max-h-[250px] lg:max-h-[400px] absolute bottom-0 right-0 -rotate-180">
            <img
              src={diplomaCurve}
              className="object-cover object-center w-full h-full block"
              alt=""
            />
          </div>
          <div className="w-full flex flex-col lg:gap-y-5 justify-evenly items-center text-center py-20">
            <div className="max-w-[80px] lg:max-w-[187]">
              <img
                src={edusognoLogoCertified}
                className="object-contain object-center w-full h-full block"
                alt=""
              />
            </div>
            <div>
              <h1 className="text-xs @sm:text-lg @2xl:text-3xl font-semibold m-2 sm:mb-4 @lg:mb-8">
                {english_course}
              </h1>
              <p className="text-[10px] @sm:text-sm font-light leading-tight @sm:leading-5">
                <strong className="font-semibold">
                  {user?.first_name} {user?.last_name}
                </strong>{" "}
                successfully participated in the <br />
                Edusogno English course with native-speaking tutors
              </p>
              <p className="text-xs @sm:text-sm font-semibold my-2">
                {start_month}
              </p>
            </div>
            <div className="flex flex-row justify-between items-center gap-20 lg:gap-24">
              <div className="flex flex-col">
                <span className="text-xs @sm:text-sm font-light">Level</span>
                <p className="text-xs @sm:text-lg font-semibold">
                  {english_level}
                </p>
              </div>
              <div>
                <span className="text-xs @sm:text-sm font-light">
                  Course Duration
                </span>
                <p className="text-xs @sm:text-lg font-semibold">
                  {course_duration} hours
                </p>
              </div>
            </div>
            <div className="flex flex-row justify-center items-center gap-x-8 mt-2">
              <p className="text-xs @sm:text-sm font-light">
                Edusogno partners
              </p>
              <div className="max-w-[80px] @4xl:max-w-full">
                <img
                  src={edusognoPartners}
                  className="object-contain object-center w-full h-full block"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PdfDiplomaPreview;
